import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment-timezone';

import GenericFormItem from '../GenericFormItem';

const Calendar = function Calendar(props) {
  const {
    val,
    label,
  } = props;
  return (
    <GenericFormItem label={label}>
      {moment(val).format('MMMM Do YYYY')}
    </GenericFormItem>
  );
};

Calendar.propTypes = {
  val: PropTypes.string,
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]),
};

export default Calendar;



// WEBPACK FOOTER //
// ./src/components/FormConfigs/Calendar.js